import { useForm } from "react-hook-form";
import { useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";

import Toggle from "../../LoginComponent/Toggle";
import BoxLegal from "../../LoginComponent/BoxLegal";
import BoxError from "../../LoginComponent/BoxError";
import { loginSuccess } from "../../../actions";
import { useDispatch } from "react-redux";
import BoxAlert from "../../LoginComponent/BoxAlert";
import Loading from "../../LoadingComponent";
import { v4 as uuidv4 } from "uuid";
import Cookies from "universal-cookie";
import axios from "axios";
import { useTranslation } from "react-i18next";

const Login = () => {
    const { t } = useTranslation();
    const [dataObj, setDataObj] = useState({});
    const [error, setError] = useState(false);
    const [errorVerify, setErrorVerify] = useState(false);
    const [resendVerify, setResendVerify] = useState(false);
    const [email, setEmail] = useState(null);
    const [loading, setLoading] = useState(false);
    const [remember, setRemember] = useState(false);
    const dispatch = useDispatch();
    const cookies = new Cookies();

    const formSchema = Yup.object().shape({
        email: Yup.string().required(t("error_required_email")),
        password: Yup.string().required(t("error_required_password")),
    });

    const formOptions = { resolver: yupResolver(formSchema) };

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm(formOptions);

    async function onSubmit(data, event) {
        event.preventDefault();
        setError(false);
        setLoading(true);
        const { email, password } = data;
        const uuid = uuidv4();
        setEmail(email);

        axios
            .post("/api/user/login", {
                email: email,
                password: password,
            })
            .then((response) => {
                setLoading(false);
                if (response.data.status == 400) {
                    if (response.data.message == "Email is not exists") {
                        setError(true);
                        setDataObj({ email: email });
                    } else if (response.data.message == "Password invalid") {
                        setError(true);
                        setDataObj({ invalid_password: true });
                    } else if (response.data.message == "Please verify your account") {
                        // setErrorVerify(true);
                        setError(true);
                        setDataObj({ is_inactive: true });
                    }
                } else {
                    // axios.post("/api/saveLoginToken", { username: username, token: uuid });

                    let d = new Date();
                    if (remember == false) {
                        d.setDate(d.getDate() + 1);
                    } else {
                        d.setDate(d.getDate() + 365);
                    }

                    cookies.set("authToken", response.data.authToken, { path: "/", expires: d });
                    dispatch(
                        loginSuccess(
                            response.data.username,
                            response.data.email, // phone
                            response.data.email,
                            response.data.role,
                            response.data.is_admin,
                            response.data.authToken // uuid
                        )
                    );

                    let date = new Date();
                    date.setDate(date.getDate() + 1);
                    window.location = `/dashboard`;
                }
            });
    }

    function resendVerifyAccount() {
        setLoading(true);
        axios
            .post("/api/user/resendVerifyAccount", {
                email: email,
                url: `${window.location.protocol}//${window.location.host}`,
            })
            .then((response) => {
                setLoading(false);

                if (response.data.status == 200) {
                    setErrorVerify(false);
                    setResendVerify(true);
                } else {
                    // console.log(response.data.status);
                }
            });
    }

    return (
        <section className="section-login-register-template login-page">
            <img
                src="/img/mbog-official-logo.png"
                alt=""
                style={{
                    margin: "0 auto 40px",
                    width: "200px",
                    height: "auto",
                    display: "block",
                }}
            />

            {loading && <Loading />}
            {errorVerify && (
                <BoxAlert
                    type="error"
                    title={t("confirm_username")}
                    btnTitle={t("btn_resent_email")}
                    action={true}
                    onClick={() => resendVerifyAccount()}
                />
            )}

            {resendVerify && <BoxAlert title={t("check_email_to_login")} />}
            {!errorVerify && !resendVerify && (
                <div className="box-login-component box-login-register-template">
                    <h2>{t("nav_log_in")}</h2>
                    <div className="wrapper-form">
                        <Toggle />
                        {error && (
                            <BoxError>
                                <>
                                    {dataObj.email && (
                                        <li>
                                            {t("user_email")} {dataObj.email} {t("no_data")}
                                        </li>
                                    )}
                                    {dataObj.invalid_password && <li>{t("password_incorrect")}</li>}
                                    {dataObj.is_inactive && <li>{t("is_inactive")}</li>}
                                </>
                            </BoxError>
                        )}

                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="container-top">
                                <div className={`group-input ${errors.email ? "error" : ""}`}>
                                    <label htmlFor="">{t("user_email")}</label>
                                    <input
                                        name="email"
                                        type="text"
                                        {...register("email", {
                                            required: true,
                                        })}
                                    />
                                    <span className="error">{errors.email?.message}</span>
                                </div>
                                <div className={`group-input ${errors.password ? "error" : ""}`}>
                                    <label htmlFor="">{t("password")}</label>
                                    <input
                                        type="password"
                                        {...register("password", {
                                            required: true,
                                        })}
                                    />
                                    {errors.password?.type === "required" && (
                                        <span className="error">{t("fill_password")}</span>
                                    )}
                                </div>

                                <div className="group-check">
                                    <div>
                                        <label
                                            htmlFor="remember"
                                            className="checkbox"
                                            onChange={() => setRemember(!remember)}
                                        >
                                            {t("remember_me")}
                                            <input type="checkbox" name="remember" id="remember" />
                                            <span className="checkmark"></span>
                                        </label>
                                    </div>
                                    <div>
                                        <a href={`/forget-password`}>{t("forget_password")}</a>
                                    </div>
                                </div>

                                <input type="submit" value={t("nav_log_in")} />
                            </div>
                        </form>
                    </div>

                    {/* <BoxLegal /> */}
                </div>
            )}
        </section>
    );
};

export default Login;
